import React from "react"
import { FlexContainer, H2 } from "@carrotfertility/carotene"
import { fetchReimbursementDetails } from "actions/reimbursementDetailsActions"
import { useStateMachine } from "components/context/stateMachine/StateMachineContext"
import useInitialSetup from "components/csd-enrollment/hooks/useInitialSetup"
import { Steps } from "components/csd-enrollment/workflow/steps"
import { useProgressTracker } from "components/views/modal/ProgressTracker"
import { CenteredLoadingIndicator } from "components/views/molecules/Molecules"
import CarrotClient from "lib/carrot-api"
import { useDispatch } from "react-redux"
import Settings from "utils/CarrotConfig"

interface ProcessConnectInsuranceStepProps {
  viewName: typeof Steps[keyof typeof Steps]
  handleVerifyInsurance: () => Promise<boolean>
}

function ProcessConnectInsuranceStep({
  viewName,
  handleVerifyInsurance
}: ProcessConnectInsuranceStepProps): JSX.Element {
  useProgressTracker(2, "CONNECT YOUR INSURANCE")
  const dispatch = useDispatch()
  const { setNextStep } = useStateMachine(viewName, null)

  useInitialSetup(async () => {
    const success = await handleVerifyInsurance()
    await dispatch(fetchReimbursementDetails())
    setNextStep(viewName, success)
  })

  return (
    <FlexContainer alignItems="center" direction="column" paddingTopBottom="large">
      <CenteredLoadingIndicator />
      <H2 variant="dark" stack="medium">
        {"We're working on your request."}
      </H2>
    </FlexContainer>
  )
}

export function MemberProcessConnectInsuranceStep(): JSX.Element {
  const viewName = Steps.MEMBER_PROCESS_CONNECT_INSURANCE

  function handleVerifyInsurance(): Promise<boolean> {
    const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
    return client.verifyMemberInsurance()
  }

  return <ProcessConnectInsuranceStep {...{ viewName, handleVerifyInsurance }} />
}

export function PartnerProcessConnectInsuranceStep(): JSX.Element {
  const viewName = Steps.PARTNER_PROCESS_CONNECT_INSURANCE

  function handleVerifyInsurance(): Promise<boolean> {
    const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
    return client.verifyPartnerInsurance()
  }

  return <ProcessConnectInsuranceStep {...{ viewName, handleVerifyInsurance }} />
}

export {
  PartnerConnectSuccess as PartnerProcessConnectInsuranceSuccessStep,
  MemberConnectSuccess as MemberProcessConnectInsuranceSuccessStep
} from "./Success"
export { PartnerConnectFailure as PartnerProcessConnectInsuranceFailureStep } from "./Failure"
